<template>
  <div class="container-fluid">
    <p class="welcome"></p>
    <div class="col-lg-12 col-sm-12 pt-3 dashboard-page">
      <div class="col-lg-6 col-sm-6 pt-3">
        <div @click="go_back()" style="cursor:pointer" class="font-weight-normal back-button mb-4">
          Back
        </div>

        <div class="dashboard-inner-new">
          <div class="panel-title mt-4">
            <p class="ptitle"><i class="fa fa-wallet"></i> Wallet Purchase</p>
          </div>

          <div class="wallet-board-new">
            <div class="avail-amount">
              <div class="topup">{{ purchaseTitle }}</div>
              <div class="add-money">{{ purchaseCopy }}</div>
            </div>
          </div>

          <div class="summary-card mt-2">
            <!-- <div class="summary-row">
              <span>{{ customerLabel }}</span>
              <strong class="customer-name">{{ paymentData.customer_name || 'N/A' }}</strong>
            </div> -->
            <div class="summary-row">
              <span>{{ customerIdLabel }}</span>
              <strong>{{ paymentData.customer_id || paymentData.meter_number || 'N/A' }}</strong>
            </div>

            <!-- <div class="summary-row">
              <span>Order Reference</span>
              <strong>{{ paymentData.order_reference || 'N/A' }}</strong>
            </div> -->
            <div class="summary-row">
              <span>Wallet Balance</span>
              <strong>&#8358;{{ formatAmount(walletBal) }}</strong>
            </div>
            <div class="summary-row total" v-if="paymentData.service_fee && Number(paymentData.service_fee) > 0">
              <span>Service Fee</span>
              <strong>&#8358;{{ formatAmount(paymentData.service_fee) }}</strong>
            </div>
            <div class="summary-row total">
              <span>Amount to Debit</span>
              <strong>&#8358;{{ formatAmount(paymentData.payment_amount) }}</strong>
            </div>
          </div>

          <div class="payment-note mt-2">
            A mock wallet charge will be created first, then you will be asked to confirm your transaction PIN.
          </div>

          <div class="btn-panel">
            <button class="btn-continue" @click="start_wallet_purchase()" v-if="!loading">
              Pay with Wallet
            </button>
            <button class="btn-continue" type="button" disabled v-if="loading">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
            <button class="btn-cancel" @click="go_back()">Cancel</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isConfirm">
      <transition name="modal">
        <div class="vcard-modal-mask">
          <div class="modal-wrapper pin-modal">
            <button class="modal-close" type="button" @click="isConfirm = false" aria-label="Close modal">
              &times;
            </button>

            <div class="pin-modal-header">
              <div class="pin-badge">
                <i class="fa fa-shield-halved"></i>
              </div>
              <div>
                <p class="pin-kicker">Transaction PIN</p>
                <h3>Confirm wallet purchase</h3>
                <p class="pin-copy">Enter your transaction PIN to authorize this {{ purchaseCopy.toLowerCase() }}.</p>
              </div>
            </div>

            <div class="pin-summary">
              <div class="pin-summary-item">
                <span>Amount</span>
                <strong>&#8358;{{ formatAmount(paymentData.payment_amount) }}</strong>
              </div>
              <div class="pin-summary-item">
                <span>Reference</span>
                <strong>{{ paymentData.order_reference }}</strong>
              </div>
            </div>

            <div class="pin-input-card">
              <label for="walletPin">Enter PIN</label>
              <input
                id="walletPin"
                v-model="transactionPin"
                type="password"
                inputmode="numeric"
                pattern="[0-9]*"
                autocomplete="off"
                placeholder="••••"
                class="pin-input"
              />
              <small>Digits only. Your PIN is never stored on the device.</small>
            </div>

            <div class="pin-actions">
              <button class="btn btn-primary btn-block" @click="confirm_wallet_purchase()" v-if="!loading4">
                Confirm Payment
              </button>
              <button class="btn btn-primary btn-block" type="button" disabled v-if="loading4">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </button>
              <button class="btn btn-link pin-cancel" @click="isConfirm = false">Cancel</button>
              <button class="btn btn-link pin-forgot" @click="forgot_pin()">Forgot PIN?</button>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="isSuccess">
      <transition name="modal">
        <div class="vcard-modal-mask">
          <div class="modal-wrapper col-md-4" style="margin:auto">
            <div class="row">
              <div class="col-md-1"></div>
              <div class="col-md-10">
                <div class="row d-flex flex-column align-items-center">
                  <p class="text-black text-uppercase text-center mt-6">Purchase successful</p>
                  <div class="success-box">
                    <p>Reference</p>
                    <strong>{{ purchaseResult.reference }}</strong>
                    <p class="mt-2">Transaction ID</p>
                    <strong>{{ purchaseResult.token || purchaseResult.reference }}</strong>
                    <p class="mt-2">Amount debited</p>
                    <strong>&#8358;{{ formatAmount(purchaseResult.amount) }}</strong>
                  </div>
                  <p class="text-center mt-3" style="font-size: 13px">
                    Your {{ successLabel }} has been validated successfully.
                  </p>
                  <button class="btn btn-primary btn-block mt-3" @click="finish_purchase()">
                    Done
                  </button>
                </div>
              </div>
              <div class="col-md-1"></div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <page-loader :is-loading="isLoading"></page-loader>
  </div>
</template>

<script>
import swal from 'sweetalert2';
import PageLoader from '../components/PageLoader.vue';
import { clearStoredSession } from '../utils/auth';

  export default {
  name: 'EtransactDataWallet',
  components: {
    PageLoader
  },
  data() {
    return {
      isLoading: false,
      loading: false,
      loading4: false,
      user_id: '',
      firstname: '',
      lastname: '',
      email_address: '',
      phone_number: '',
      walletBal: 0,
      paymentData: {
        utility: 'data',
        account_type: '',
        name: '',
        payment_amount: 0,
        amount: 0,
        company_package: '',
        productId: '',
        company_name: '',
        plan_name: '',
        meter_number: '',
        meter_type: '',
        network: '',
        order_reference: '',
        service_fee: 150,
        customer_name: '',
        customer_id: '',
        createdAt: null
      },
      transactionPin: '',
      isConfirm: false,
      isSuccess: false,
      walletPinAttempts: 0,
      maxWalletPinAttempts: 4,
      purchaseResult: {
        token: '',
        reference: '',
        amount: 0
      }
    };
  },
  beforeMount() {
    this.user_id = localStorage.getItem('userid');
  },
  mounted() {
    this.firstname = localStorage.getItem('firstname');
    this.lastname = localStorage.getItem('lastname');
    this.email_address = localStorage.getItem('email');
    this.phone_number = localStorage.getItem('phone');
    this.user_id = localStorage.getItem('userid');

    this.load_payment_data();
    this.get_wallet_balance();
  },
  computed: {
    isCableTvPurchase() {
      return String(this.paymentData.utility || '').toLowerCase() === 'cabletv';
    },
    purchaseTitle() {
      return this.isCableTvPurchase ? 'Cable TV Purchase' : 'Data Purchase';
    },
    purchaseCopy() {
      return this.isCableTvPurchase
        ? 'Use your wallet balance to complete this cable TV subscription instantly'
        : 'Use your wallet balance to complete this data subscription instantly';
    },
    customerLabel() {
      return this.isCableTvPurchase ? 'Customer' : 'Customer';
    },
    customerIdLabel() {
      return this.isCableTvPurchase ? 'Smart Card Number' : 'Phone Number';
    },
    successLabel() {
      return this.isCableTvPurchase ? 'cable TV purchase' : 'data purchase';
    },
    backRoute() {
      return this.isCableTvPurchase ? '/cable-tv/purchase' : '/data/purchase';
    },
    storageKey() {
      return 'dataWalletPurchase';
    }
  },
  methods: {
    load_payment_data() {
      const saved = localStorage.getItem(this.storageKey);

      if (!saved) {
        swal.fire({
          icon: 'warning',
          title: 'Missing purchase data',
          width: 450,
          text: 'Please start the purchase again.',
        }).then(() => {
          this.go_back();
        });
        return;
      }

      try {
        this.paymentData = {
          ...this.paymentData,
          ...JSON.parse(saved)
        };
      } catch (err) {
        console.log(err);
        this.go_back();
      }
    },
    formatAmount(amount) {
      const value = Number(amount || 0);
      return value.toLocaleString('en-NG', {
        minimumIntegerDigits: 2,
        maximumFractionDigits: 2
      });
    },
    async get_wallet_balance() {
      try {
        const response = await this.$http.post('/fetch-wallet-balance', {
          userid: this.user_id,
        });
        this.walletBal = response.data.balance || 0;
      } catch (err) {
        console.log(err);
      }
    },
    async simulate_wallet_preview() {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            success: true,
            reference: 'WLT-' + Date.now().toString().slice(-8)
          });
        }, 1100);
      });
    },
    async simulate_wallet_validation(pin) {
      try {
        const response = await this.$http.post('/validate-pin', {
          phone_number: this.phone_number,
          pin: pin
        });

        if (!response.data.success) {
          this.walletPinAttempts += 1;
          const remainingAttempts = Math.max(this.maxWalletPinAttempts - this.walletPinAttempts, 0);
          const lockoutMessage = this.walletPinAttempts >= this.maxWalletPinAttempts
            ? 'You have entered an invalid PIN too many times. You will now be signed out and redirected to reset your PIN.'
            : `Invalid transaction PIN. You have ${remainingAttempts} attempt${remainingAttempts === 1 ? '' : 's'} left.`;

          swal.fire({
            icon: this.walletPinAttempts >= this.maxWalletPinAttempts ? 'error' : 'warning',
            title: this.walletPinAttempts >= this.maxWalletPinAttempts ? 'PIN locked' : 'PIN error',
            width: 450,
            text: lockoutMessage,
          }).then(() => {
            if (this.walletPinAttempts >= this.maxWalletPinAttempts) {
              this.logout_for_pin_reset();
            }
          });

          return {
            success: false,
            message: response.data.message || lockoutMessage,
            attempts: this.walletPinAttempts,
            locked: this.walletPinAttempts >= this.maxWalletPinAttempts
          };
        }

        this.walletPinAttempts = 0;
        return {
          success: true,
          message: response.data.message || 'PIN validated successfully'
        };
      } catch (err) {
        console.log(err);
        this.walletPinAttempts += 1;
        const remainingAttempts = Math.max(this.maxWalletPinAttempts - this.walletPinAttempts, 0);
        const lockoutMessage = this.walletPinAttempts >= this.maxWalletPinAttempts
          ? 'Unable to validate your PIN after multiple attempts. You will now be signed out and redirected to reset your PIN.'
          : `We could not validate your PIN right now. You have ${remainingAttempts} attempt${remainingAttempts === 1 ? '' : 's'} left.`;

        swal.fire({
          icon: this.walletPinAttempts >= this.maxWalletPinAttempts ? 'error' : 'warning',
          title: this.walletPinAttempts >= this.maxWalletPinAttempts ? 'PIN locked' : 'PIN error',
          width: 450,
          text: lockoutMessage,
        }).then(() => {
          if (this.walletPinAttempts >= this.maxWalletPinAttempts) {
            this.logout_for_pin_reset();
          }
        });

        return {
          success: false,
          message: err.response ? err.response.data.message : err.message,
          attempts: this.walletPinAttempts,
          locked: this.walletPinAttempts >= this.maxWalletPinAttempts
        };
      }
    },
    async start_wallet_purchase() {
      try {
        if (!this.paymentData.order_reference) {
          swal.fire({
            icon: 'warning',
            title: 'Warning',
            width: 450,
            text: 'Missing order reference for this purchase.',
          });
          return;
        }

        if (Number(this.walletBal) < Number(this.paymentData.payment_amount)) {
          swal.fire({
            icon: 'warning',
            title: 'Low balance',
            width: 450,
            text: 'Your wallet balance is not enough for this purchase.',
          });
          return;
        }

        this.loading = true;
        await this.simulate_wallet_preview();
        this.loading = false;
        this.isConfirm = true;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    async confirm_wallet_purchase() {
      try {
        const enteredPin = String(this.transactionPin || '').trim();

        if (!enteredPin) {
          swal.fire({
            icon: 'warning',
            title: 'Warning',
            width: 450,
            text: 'Please enter your transaction pin.',
          });
          return;
        }

        this.loading4 = true;
        const response = await this.simulate_wallet_validation(enteredPin);
        
        if (!response.success) {
          this.loading4 = false;
          return;
        }

        const amount = this.paymentData.amount || this.paymentData.payment_amount;
        const purchasePayload = this.isCableTvPurchase
          ? {
              smart_card_number: this.paymentData.meter_number || this.paymentData.customer_id,
              productId: this.paymentData.productId || this.paymentData.company_package || this.paymentData.plan_name,
              network: this.paymentData.network || this.paymentData.meter_type || this.paymentData.company_name,
              userid: this.user_id,
              amount,
              email: this.email_address,
              phone_number: this.smart_card_number,
              account_type: this.paymentData.company_package,
              name: this.paymentData.name
            }
          : {
              reference: this.paymentData.order_reference,
              amount,
              email: this.email_address,
              phone_number: this.phone_number,
              productId: this.paymentData.productId || this.paymentData.company_package
            };

        const purchaseResponse = await this.$http.post(
          this.isCableTvPurchase ? '/xpresspay/cabletv-wallet-purchase' : '/xpresspay/data-wallet-purchase',
          purchasePayload
        );

        this.loading4 = false;

        if (!purchaseResponse.data.success) {
          swal.fire({
            icon: 'error',
            title: 'Purchase failed',
            width: 450,
            text: purchaseResponse.data.message || 'Wallet purchase could not be completed.',
          });
          this.loading4 = false;
          return;
        }

        this.purchaseResult = {
          token: purchaseResponse.data.token || purchaseResponse.data.reference || '',
          reference: purchaseResponse.data.reference || this.paymentData.order_reference || ('WLT-' + Date.now().toString().slice(-8)),
          amount: purchaseResponse.data.amount || this.paymentData.payment_amount
        };
        this.transactionPin = '';
        this.isConfirm = false;
        this.isSuccess = true;
      } catch (err) {
        console.log(err);
        this.loading4 = false;
      }
    },
    finish_purchase() {
      localStorage.removeItem(this.storageKey);
      this.$router.push(this.backRoute);
    },
    forgot_pin() {
      clearStoredSession();
      localStorage.removeItem(this.storageKey);
      this.transactionPin = '';
      this.isConfirm = false;
      this.loading = false;
      this.loading4 = false;
      this.$router.push('/forgot-password');
    },
    logout_for_pin_reset() {
      clearStoredSession();
      localStorage.removeItem(this.storageKey);
      localStorage.removeItem("bank_name");
      localStorage.removeItem("account_name");
      localStorage.removeItem("account_number");
      this.transactionPin = '';
      this.isConfirm = false;
      this.loading = false;
      this.loading4 = false;
      this.walletPinAttempts = 0;
      this.$router.push('/forgot-password');
    },
    go_back() {
      this.$router.push(this.backRoute);
    }
  }
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;700&display=swap');

.container-fluid{
  background: #cccccc41;
  border-radius: 10px;
  min-height: 100vh;
}

.welcome{
  font-family: Poppins;
  font-size: 18px;
  font-weight: normal;
  padding: 0px 20px;
  text-align: left;
  color: #170e0fac;
}

.dashboard-page{
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  background: transparent;
  padding: 0.6rem;
  font-family: Poppins;
}

.dashboard-inner-new{
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  padding: 18px 35px 18px 35px;
  gap: 10px;
  border-radius: 16px;
  border: 3px solid #F4F4F4;
  background: #FFFFFF;
}

.back-button{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 40px;
  border-radius: 102px;
  background: #D9D9D9;
  color: #fff;
}

.panel-title{
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
}

.ptitle{
  font-size: 17px;
  font-weight: 500;
  text-align: left;
}

.wallet-board-new{
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  padding: 0.9rem;
  border-radius: 13px;
  background: #24562B;
  color: #fff;
}

.avail-amount{
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: center;
}

.topup{
  font-size: 25px;
  font-weight: 500;
}

.add-money{
  font-size: 11px;
  font-weight: 400;
  color: #fff;
}

.summary-card{
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 15px;
  border-radius: 12px;
  background: #ECF3FF;
  border: 1px solid #E8EBF0;
}

.summary-row{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
  color: #5f5f5f;
}

.summary-row strong{
  color: #111;
  text-align: right;
}

.summary-row.total{
  padding-top: 10px;
  border-top: 1px solid #d8dde8;
}

.payment-note{
  font-size: 12px;
  color: #7F7F7F;
}

.btn-panel{
  display: flex;
  flex-direction: column;
  align-items: center;
}

.btn-continue{
  width: 300px;
  height: 52px;
  padding: 0px 36px;
  border-radius: 9px;
  background: #24562B;
  color: #fff;
  text-transform: uppercase;
  font-family: Montserrat;
  font-size: 15px;
  font-weight: 700;
}

.btn-cancel{
  width: 300px;
  height: 52px;
  padding: 0px 36px;
  border-radius: 9px;
  background: #fff;
  color: #000;
  text-transform: uppercase;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 300;
}

.vcard-modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 16px;
  background: rgba(9, 18, 12, 0.62);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity .4s ease;
}

.pin-modal{
  position: relative;
  width: min(92vw, 460px);
  padding: 28px;
  border-radius: 22px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbf8 100%);
  border: 1px solid rgba(36, 86, 43, 0.12);
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.24);
  font-family: Poppins;
  overflow: hidden;
}

.pin-modal::before{
  content: "";
  position: absolute;
  inset: 0 auto auto 0;
  width: 100%;
  height: 6px;
  background: linear-gradient(90deg, #24562B 0%, #3d7a49 100%);
}

.modal-close{
  position: absolute;
  top: 14px;
  right: 14px;
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 999px;
  background: rgba(36, 86, 43, 0.08);
  color: #24562B;
  font-size: 26px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pin-modal-header{
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-top: 8px;
  padding-right: 28px;
}

.pin-badge{
  width: 54px;
  height: 54px;
  flex: 0 0 54px;
  border-radius: 16px;
  background: linear-gradient(135deg, #24562B 0%, #3d7a49 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 24px rgba(36, 86, 43, 0.24);
}

.pin-badge i{
  font-size: 20px;
}

.pin-kicker{
  margin: 0 0 4px;
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #24562B;
  font-weight: 700;
}

.pin-modal-header h3{
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #172018;
}

.pin-copy{
  margin: 6px 0 0;
  font-size: 13px;
  color: #69736d;
  line-height: 1.5;
}

.pin-summary{
  margin-top: 20px;
  padding: 16px;
  border-radius: 16px;
  background: #f3f7f4;
  border: 1px solid rgba(36, 86, 43, 0.08);
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.pin-summary-item{
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.pin-summary-item span{
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #7b847f;
  font-weight: 700;
}

.pin-summary-item strong{
  font-size: 14px;
  color: #132017;
}

.pin-input-card{
  margin-top: 18px;
  padding: 16px;
  border-radius: 16px;
  background: #fff;
  border: 1px solid #e3e9e4;
}

.pin-input-card label{
  display: block;
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 700;
  color: #4e5853;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.pin-input{
  width: 100%;
  height: 56px;
  padding: 0 16px;
  border-radius: 14px;
  border: 1px solid #cfd9d1;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbf8 100%);
  color: #172018;
  font-size: 22px;
  letter-spacing: 0.35em;
  text-align: center;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.65);
  outline: none;
}

.pin-input:focus{
  border-color: #24562B;
  box-shadow: 0 0 0 4px rgba(36, 86, 43, 0.10);
}

.pin-input::placeholder{
  color: #b1b8b3;
  letter-spacing: 0.35em;
}

.pin-input-card small{
  display: block;
  margin-top: 10px;
  font-size: 12px;
  color: #7b847f;
}

.pin-actions{
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 18px;
}

.pin-cancel{
  color: #6b736e;
  text-decoration: none;
  font-size: 13px;
  font-weight: 600;
}

.pin-forgot{
  color: #24562B;
  text-decoration: none;
  font-size: 13px;
  font-weight: 700;
}

.btn-primary{
  width: 100%;
  height: 52px;
  padding: 0px 36px;
  border-radius: 9px;
  background: #24562B;
  color: #fff;
  text-transform: uppercase;
  font-family: Montserrat;
  font-size: 15px;
  font-weight: 700;
}

.success-box{
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  background: #f4fff5;
  border: 1px solid #d9f3dd;
  text-align: center;
}

.success-box p{
  margin-bottom: 0;
  font-size: 12px;
  color: #24562B;
}

.success-box strong{
  display: block;
  font-size: 16px;
  color: #111;
}

@media screen and (max-width: 768px) {
  .container-fluid{
    padding: 0 0px 0 0rem;
  }

  .welcome{
    font-size: 16px;
    font-weight: 700;
    padding: 0px 15px;
  }

  .dashboard-page{
    display: flex;
    flex-direction: column;
  }

  .dashboard-inner-new{
    width: 100%;
    padding: 0.8rem;
  }

  .btn-continue,
  .btn-cancel{
    width: 100%;
    font-size: 13px;
  }

  .pin-modal{
    width: min(94vw, 460px);
    padding: 22px 18px;
    border-radius: 18px;
  }

  .pin-modal-header{
    gap: 12px;
  }

  .pin-badge{
    width: 48px;
    height: 48px;
    flex-basis: 48px;
    border-radius: 14px;
  }

  .pin-modal-header h3{
    font-size: 19px;
  }

  .pin-summary{
    grid-template-columns: 1fr;
  }

  .pin-input{
    height: 54px;
    font-size: 20px;
  }

  .topup{
    font-size: 22px;
  }

  .summary-row .customer-name {
    font-size: 10px;
    text-align: right;
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: normal;
    line-height: 1.4;
  }

  .summary-row{
    font-size: 10px;
  }

  .summary-row strong{
    font-size: 10px;
  }
}
</style>
